import { Button } from '@calendly/ui/components/button';
import { InlineBanner } from '@calendly/ui/components/inline-banner';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useUpgradeSubscription } from 'components/billing/use_upgrade_subscription';
const bannerMessageCss = "b15at68u";
const bannerTextCss = "b1r3tufb";
export const UpgradeInlineBanner = ({
  title,
  message,
  explorePlansLabel,
  featureKey,
  paywall,
  'data-testid': dataTestId
}) => {
  const openExplorePlans = useUpgradeSubscription({
    featureKey,
    skipPreface: true,
    paywall,
    type: 'inline'
  });
  return <div data-testid={dataTestId}>
      <InlineBanner variant="info" hasIcon={false} isDismissible={false} message={<div className={bannerMessageCss}>
            <div className={bannerTextCss}>
              <TitleText level={5} size="x-small" as="p">
                {title}
              </TitleText>
              <BodyText>{message}</BodyText>
            </div>
            <Button decoration="primary" size="small" responsive={false} onClick={openExplorePlans}>
              {explorePlansLabel}
            </Button>
          </div>} />
    </div>;
};

require("./upgrade_inline_banner.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./upgrade_inline_banner.js");